import * as yup from 'yup';

export const parameterFormSchema = yup.object({
  title: yup.string().trim().required('required').max(200),
  weightPercent: yup
    .number()
    .typeError('required')
    .required('required')
    .min(0)
    .max(100)
    .transform((value, originalValue) =>
      originalValue === '' || originalValue == null ? undefined : value,
    ),
  categoryTitle: yup.string().trim().optional().default(''),
  categorySortOrder: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue == null ? null : value))
    .optional()
    .default(null),
});

export type ParameterFormValues = {
  title: string;
  weightPercent: number;
  categoryTitle: string;
  categorySortOrder: number | null;
};
